export class verify_res {
    exists:Boolean;
    auth:Boolean;
}